module.exports = __webpack_public_path__ + "static/media/folded.562326c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/folded.svg
// module id = 998
// module chunks = 47